// Team-Members
document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('.team-trigger');
    const detailPanel = document.getElementById('team-detail-panel');
    let activeMemberId = null;

    function isMobile() {
        return window.innerWidth <= 991;
    }

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            const id = this.getAttribute('data-member-id');
            const content = document.getElementById('team-content-' + id);
            if (!content) return;

            // Close if clicking the same member again
            if (activeMemberId === id) {
                if (isMobile()) {
                    const existingPanel = document.querySelector('.inserted-detail-panel');
                    if (existingPanel) existingPanel.remove();
                } else {
                    detailPanel.innerHTML = '';
                    detailPanel.classList.add('d-none');
                }
                activeMemberId = null;
                return;
            }

            activeMemberId = id;

            if (isMobile()) {
                // MOBILE VIEW: insert bio directly below the clicked team member
                // Remove any existing open panels first
                document.querySelectorAll('.inserted-detail-panel').forEach((panel) => panel.remove());

                const col = this.closest('.col-lg-4, .col-12');
                if (!col) return;

                const newPanel = document.createElement('div');
                newPanel.classList.add('inserted-detail-panel', 'w-100');
                newPanel.innerHTML = content.innerHTML;

                col.insertAdjacentElement('afterend', newPanel);
            } else {
                // DESKTOP VIEW: insert in shared detail panel after row of 4
                const col = this.closest('.col-lg-4');
                if (!col) return;

                const parentRow = col.parentElement;
                const allCols = [...parentRow.querySelectorAll('.col-lg-4')];
                const colIndex = allCols.indexOf(col);
                const isLastInRow = (colIndex + 1) % 3 === 0 || colIndex === allCols.length - 1;
                const insertAfterIndex = isLastInRow
                    ? colIndex
                    : Math.min(Math.floor(colIndex / 3) * 3 + 2, allCols.length - 1);

                const insertAfterEl = allCols[insertAfterIndex];
                insertAfterEl.insertAdjacentElement('afterend', detailPanel);
                detailPanel.innerHTML = content.innerHTML;
                detailPanel.classList.remove('d-none');
            }
        });
    });

    // Close bio
    document.addEventListener('click', function (e) {
        const closeBtn = e.target.closest('.team-close');
        if (closeBtn) {
            if (isMobile()) {
                const panel = closeBtn.closest('.inserted-detail-panel');
                if (panel) panel.remove();
            } else {
                detailPanel.innerHTML = '';
                detailPanel.classList.add('d-none');
            }
            activeMemberId = null;
        }
    });

    // Handle window resize (close open bios if resizing between mobile/desktop)
    window.addEventListener('resize', () => {
        if (isMobile()) {
            detailPanel.innerHTML = '';
            detailPanel.classList.add('d-none');
        } else {
            document.querySelectorAll('.inserted-detail-panel').forEach((panel) => panel.remove());
        }
        activeMemberId = null;
    });
});
